module.exports = __webpack_public_path__ + "img/contr-1Icon@2x.c7a1c815.svg";